/**
 * Data layer for `vertical-aware-fraud-rules-igaming-vs-fintech-vs-e`. Thin typed fetch wrappers over /api/v1/vertical-aware-fraud-rules-igaming-vs-fintech-vs-e.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface VerticalAwareFraudRulesIgamingVsFintechVsERow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListVerticalAwareFraudRulesIgamingVsFintechVsEResponse {
	count: number;
	items: VerticalAwareFraudRulesIgamingVsFintechVsERow[];
}

export interface CreateVerticalAwareFraudRulesIgamingVsFintechVsEBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/vertical-aware-fraud-rules-igaming-vs-fintech-vs-e";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListVerticalAwareFraudRulesIgamingVsFintechVsEResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListVerticalAwareFraudRulesIgamingVsFintechVsEResponse>(res);
}

export async function create(body: CreateVerticalAwareFraudRulesIgamingVsFintechVsEBody): Promise<VerticalAwareFraudRulesIgamingVsFintechVsERow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<VerticalAwareFraudRulesIgamingVsFintechVsERow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys = {
	all: ["vertical-aware-fraud-rules-igaming-vs-fintech-vs-e"] as const,
	list: () => [...verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys.all] as const,
	detail: (id: string) => [...verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys.all, id] as const,
};
